/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Pricing Component
 * @param price
 * @param strikeThrough
 * @param currency
 * @param sx
 * @param hasAdditionalCondition
 * @returns {JSX.Element}
 * @constructor
 */
export function Pricing({
  price,
  strikeThrough,
  currency,
  sx,
  hasAdditionalCondition,
}) {
  const diagonalLineBefore = {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(to bottom right, transparent calc(50% - 2px), red, transparent calc(50% + 2px))',
  };

  // const priceParts = price.toString().split('.');
  const priceParts = (parseFloat(price)).toFixed(2)
    .toString()
    .split('.');

  return (
    <Box
      style={{
        fontSize: '30px',
        lineHeight: '1',
        textAlign: 'center',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        opacity: (strikeThrough ? '0.6' : '1'),
        ...sx,
      }}
    >
      {strikeThrough && <span style={diagonalLineBefore} />}
      <Box style={{
        padding: '4px',
        position: 'relative',
        display: 'inline-block',
      }}
      >
        <span>{priceParts[0]}</span>
      </Box>
      <Box style={{ fontSize: '12px' }}>
        {priceParts[1] ? priceParts[1] : '00'}
        {' '}
        {currency}
        <br />
        mtl.
        {' '}
        {hasAdditionalCondition ? '*' : null}
      </Box>
    </Box>
  );
}

Pricing.propTypes = {
  hasAdditionalCondition: PropTypes.bool,
  price: PropTypes.number.isRequired,
  strikeThrough: PropTypes.bool,
  currency: PropTypes.string,
  sx: PropTypes.object,
};

Pricing.defaultProps = {
  hasAdditionalCondition: false,
  strikeThrough: false,
  currency: '€',
  sx: {},
};
